<template>
  <div >
    <img class="navbar-brand-full" src="/img/is/nusanet.png" height="42" alt="Nusanet">
    <div>
      <strong><u>Bonus Presensi Periode {{start}} - {{end}}</u></strong>
    </div>
     <table class="insentif" border="1">
       <thead class="bg-success">
        <tr>
          <th>No</th>
          <th style="text-align: center">Nama Staff</th>
          <th style="text-align: center">Jumlah (Rp)</th>
          <th></th>
        </tr>
       </thead>
       <tbody>
          <template v-for="(data, i) in summaryDetail">
            <tr>
              <td align="right">{{i + 1}}</td>
              <td>{{data.name}}</td>
              <td align="right">{{data.incentive_value | pointmoneynotCurrency}}</td>
              <td><em class="text-info">{{data.incentive_note}}</em></td>
            </tr>
          </template>
            <tr class="bg-info">
              <td colspan="2" align="center">TOTAL</td>
              <td align="right">{{total(summary)}}</td>
              <td></td>
            </tr>
       </tbody>
     </table>
  </div>
</template>
<script>
  export default{
    data() {
      return {
        summaryDetail :[]
      }
    },
    created() {
      this.summaryDetail = this.summary.filter(data=> data.incentive)
    },
    watch: {
      summary: {
        handler: function(val) {
          this.summaryDetail = this.summary.filter(data=> data.incentive)
        }
      }
    },
    props: {
      start: {
        type: String,
        default: ''
      },
      end: {
        type: String,
        default: ''
      },
      summary: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      total(data) {
        let total = 0
        for(let i =0; i < data.length ; i++) {
          if(data[i].incentive) {
            total += Number(data[i].incentive_value)
          }
        }
        return total.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
      }
    }
  }
</script>
<style >

  table.insentif>thead>tr>th,
  table.insentif>tbody>tr>td
  {
    border: 1px solid #000000;
  }
  table.insentif,
  table.insentif>thead>tr>th:last-child,
  table.insentif>tbody>tr>td:last-child
  {
    border: none !important;
    background-color: #ffffff;
  }

  @media print {
    body {
      margin: 0;
      color: #000;
      background-color: #fff;
    }
    table.insentif>thead>tr>th,
    table.insentif>tbody>tr>td
    {
      border: 1px solid #000000;
    }
    table.insentif,
    table.insentif>thead>tr>th:last-child,
    table.insentif>tbody>tr>td:last-child
    {
      border: none !important;
      background-color: #ffffff;
    }
  }
</style>
